import axios from '@/plugins/axios'

const state = {
    reseller: {},
}

const getters = {
    reseller: state => state.reseller,
    current: state => state.reseller,
    name: state => state.reseller.trade_name,
    billable: state => state.reseller.billable,
    isWhitelabel: state => state.reseller.type_referable == 'whitelabel',
    isNotWhitelabel: state => state.reseller.type_referable != 'whitelabel',
    isReseller: state => state.reseller.type_referable == 'reseller',
    isPartner: state => state.reseller.type_referable == 'partner',
    isBusinessConsultant: state =>
        state.reseller.type_referable == 'business_consultant',
    hasSupport: state => state.reseller.has_support,
    isBlockedForDefaulting: state =>
        state.reseller.is_blocked_for_defaulting || false,
}

const actions = {
    async getReseller({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get('/auth/me')
                .then(res => {
                    if (typeof res != 'undefined') {
                        commit('setReseller', res.data.reseller)
                    }

                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    setReseller({ commit }, data) {
        commit('setReseller', data)
    },
}

const mutations = {
    setReseller(state, reseller) {
        state.reseller = reseller
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
